<template>
  <div>
    <el-card class="box-card">
      <el-form :model="editData" ref="editDataRef" label-width="110px">
        <el-form-item label="类型">
          <el-select v-model="editData.honortype" placeholder="请选择" class="select">
            <el-option
              v-for="item in honortypeList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标题" class="addAdminForm">
          <el-input v-model="editData.title" placeholder="请输入标题"></el-input>
        </el-form-item>
        <el-form-item label="图片链接" class="addAdminForm">
          <el-input v-model="editData.picurl" placeholder="请输入图片链接"></el-input>
        </el-form-item>
        <el-form-item label="排序" class="addAdminForm">
          <el-input v-model="editData.listorder" placeholder="请输入排序"></el-input>
        </el-form-item>
        <el-form-item class="mt20">
          <el-button type="primary" @click="clicksave">保存</el-button>
          <el-button type="info" @click="clickreturn">返回</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import VueUeditorWrap from 'vue-ueditor-wrap'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    VueUeditorWrap
  },
  data () {
    return {
      honortypeList: [],
      editData: {
        id: '0',
        honortype: '',
        title: '',
        picurl: '',
        listorder:''
      }
    }
  },
  mounted () {
    this.honortypeList = Vue.prototype.FunGetHonortype()
  },
  methods: {
    LoadData (row) {
      this.editData.id = row.Id
      this.editData.honortype = row.Honortype.toString()
      this.editData.title = row.Title
      this.editData.picurl = row.Picurl
      this.editData.listorder = row.Listorder
    },
    clickreturn () {
      this.$emit('triggerFunc', '')
    },
    clicksave () {
      this.EditKgjtWebsiteHonor()
    },
    EditKgjtWebsiteHonor: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: that.editData.id,
        honortype: that.editData.honortype,
        title: that.editData.title,
        picurl: that.editData.picurl,
        listorder: that.editData.listorder
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditKgjtWebsiteHonor, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 365px;
}
</style>
